import React from 'react';
import {
  Box,
  Container,
  Flex,
  Grid,
  GridItem,
  Heading,
  Image,
  Link,
  Stack,
  Text,
  Icon,
  useBreakpointValue,
} from '@chakra-ui/react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { COLORS } from '../utils/constants';

const Footer = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box 
      as="footer" 
      bg="black" 
      color="white" 
      py={{ base: 10, md: 16 }}
      borderTop="1px solid"
      borderColor="rgba(30, 220, 11, 0.3)"
      position="relative"
      zIndex={1}
    >
      <Container maxW="7xl">
        {/* Logo and Social Links Section */}
        <Flex 
          direction="column" 
          align={{ base: "center", md: "flex-start" }}
          mb={{ base: 10, md: 14 }}
        >
          <Image 
            src="/IgnitaLogo.svg" 
            alt="Ignita Logo" 
            height={{ base: "40px", md: "50px" }} 
            mb={6}
          />
          
          <Flex gap={4}>
            <Link href="https://discord.gg/dDyGwzvyNR" isExternal>
              <Box 
                as="span" 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                w="40px" 
                h="40px" 
                borderRadius="md" 
                bg="rgba(255, 255, 255, 0.1)"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                </svg>
              </Box>
            </Link>
            <Link href="https://x.com/XgcLabs" isExternal>
              <Box 
                as="span" 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                w="40px" 
                h="40px" 
                borderRadius="md" 
                bg="rgba(255, 255, 255, 0.1)"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </Box>
            </Link>
            <Link href="https://www.linkedin.com/company/xgc-labs/" isExternal>
              <Box 
                as="span" 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                w="40px" 
                h="40px" 
                borderRadius="md" 
                bg="rgba(255, 255, 255, 0.1)"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </Box>
            </Link>
          </Flex>
        </Flex>
        
        {/* Footer Links Section */}
        <Grid 
          templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
          gap={{ base: 8, md: 6 }}
        >
          {/* Ecosystem Section */}
          <GridItem>
            <Heading 
              as="h3" 
              fontSize="xl" 
              fontWeight="bold" 
              mb={6}
              fontFamily="Montserrat,system-ui,sans-serif"
            >
              ECOSYSTEM
            </Heading>            <Stack spacing={4}>
              <Link 
                href="https://swap.xgclabs.io/" 
                display="flex" 
                alignItems="center" 
                _hover={{ color: COLORS.primary }}
                isExternal
              >
                <Icon as={FaExternalLinkAlt} boxSize={3} mr={2} />
                <Text>Swap</Text>
              </Link>

              <Link 
                href="https://launchpad.xgclabs.io/" 
                display="flex" 
                alignItems="center" 
                _hover={{ color: COLORS.primary }}
                isExternal
              >
                <Icon as={FaExternalLinkAlt} boxSize={3} mr={2} />
                <Text>Launchpad</Text>
              </Link>
            </Stack>
          </GridItem>
          
          {/* Documentation Section */}
          <GridItem>
            <Heading 
              as="h3" 
              fontSize="xl" 
              fontWeight="bold" 
              mb={6}
              fontFamily="Montserrat,system-ui,sans-serif"
            >
              DOCUMENTATION
            </Heading>            <Stack spacing={4}>
              <Link 
                href="https://drive.google.com/file/d/1gpoiE9n6Wxj2is2Cuqzd9dfNSN0sZLxA/view?usp=drive_link" 
                display="flex" 
                alignItems="center" 
                _hover={{ color: COLORS.primary }}
                isExternal
              >
                <Icon as={FaExternalLinkAlt} boxSize={3} mr={2} />
                <Text>Whitepaper</Text>
              </Link>
            </Stack>
          </GridItem>
          
          {/* Help & Support Section */}
          <GridItem>
            <Heading 
              as="h3" 
              fontSize="xl" 
              fontWeight="bold" 
              mb={6}
              fontFamily="Montserrat,system-ui,sans-serif"
            >
              HELP & SUPPORT
            </Heading>            <Stack spacing={4}>
              <Link 
                href="mailto:Contact@xgclabs.io" 
                display="flex" 
                alignItems="center" 
                _hover={{ color: COLORS.primary }}
              >
                <Icon as={FaExternalLinkAlt} boxSize={3} mr={2} />
                <Text>Contact</Text>
              </Link>              <Link 
                href="#faq" 
                display="flex" 
                alignItems="center" 
                _hover={{ color: COLORS.primary }}
                onClick={(e) => {
                  e.preventDefault();
                  const faqSection = document.getElementById('faq');
                  if (faqSection) {
                    faqSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                <Icon as={FaExternalLinkAlt} boxSize={3} mr={2} />
                <Text>FAQ</Text>
              </Link>
            </Stack>
          </GridItem>
          
          {/* Legal Section */}
          <GridItem>
            <Heading 
              as="h3" 
              fontSize="xl" 
              fontWeight="bold" 
              mb={6}
              fontFamily="Montserrat,system-ui,sans-serif"
            >
              LEGAL
            </Heading>            <Stack spacing={4}>
              <Link 
                href="https://xgclabs.io/privacy-policy" 
                display="flex" 
                alignItems="center" 
                _hover={{ color: COLORS.primary }}
                isExternal
              >
                <Icon as={FaExternalLinkAlt} boxSize={3} mr={2} />
                <Text>Privacy Policy</Text>
              </Link>
              <Link 
                href="#" 
                display="flex" 
                alignItems="center" 
                _hover={{ color: COLORS.primary }}
              >
                <Icon as={FaExternalLinkAlt} boxSize={3} mr={2} />
                <Text>Terms & Conditions</Text>
              </Link>
            </Stack>
          </GridItem>
        </Grid>
        
        {/* Copyright Section */}
        <Box 
          mt={{ base: 10, md: 16 }} 
          textAlign={{ base: "center", md: "left" }}
          color="gray.400"
          fontSize="sm"
        >
          <Text>© {new Date().getFullYear()} Ignita. All rights reserved.</Text>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;